import React from "react";
import AircraftTypesContent from "../components/aircraftTypes/aircraftTypes-content";

const AircraftTypes = () => {
  return <AircraftTypesContent />;
};

export default AircraftTypes;
